import { MDBAlert } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteAuthUser } from '../../../apiclients/streamsapi_bridge';

const DeleteAutherizedUser = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const removeAuthorized = async (e) => {
        try {
            setInternalError(false);
            props.setIsloading(true);
            let deleteaddressReponse = await deleteAuthUser(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.id);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteaddressReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);


            } else {
                localStorage.setItem("f_message", delInfo.message);

            }
            props.onClose();
            navigate("/securityregistrationlanding", {
                state: { tab: "tab5" },
            });
            window.location.reload();
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }

    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{t("RemoveAuthorizedUsertxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeAuthorized(e)}>
                    {t("remove")}</button>
            </div>

        </>
    )
});


export default DeleteAutherizedUser
